import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { CasbinPermissionsService } from '../../services/feature/casbin-permissions.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permissions = inject(CasbinPermissionsService);
  const dccCode = route.paramMap.get('dccCode');

  if (auth.authProfile()?.isAdmin || permissions.hasFullAccess()) {
    return true;
  }

  if (!permissions.hasBusinessEntityAccess(dccCode)) {
    const returnTo = state.url.split('/').slice(0, 3).join('/');
    const accessDeniedPath = returnTo.startsWith('/dock-menu/')
      ? [returnTo, 'access-denied']
      : ['/access-denied'];

    return router.createUrlTree(accessDeniedPath, {
      queryParams: {
        returnTo,
        dccCode,
        reason: 'no-permission',
        attemptedRoute: route.routeConfig?.path,
      },
    });
  }

  const returnTo = state.url.split('/').slice(0, 3).join('/');
  const feature = route.data?.['featureLabel'];
  const accessDeniedPath = returnTo.startsWith('/dock-menu/')
    ? [returnTo, 'access-denied']
    : ['/access-denied'];

  return router.createUrlTree(accessDeniedPath, {
    queryParams: {
      returnTo,
      feature,
      dccCode,
      reason: 'no-permission',
      attemptedRoute: route.routeConfig?.path,
    },
  });
};
